<template>
  <section class="page-view">
    <div class="banner02">
      <img src="/static/images/gisagro4.0/banner-service.png" />
      <div class="text">
        <span>พัฒนาแพลตฟอร์ม</span>
        <label>เพื่อการให้บริการระบบอย่างครบวงจร</label>
      </div>
    </div>
    <div style="padding:8px 10px">
      <div class="title center">
        การให้บริการและสนับสนุน
      </div>
      <div class="paragraph">
        <img src="/static/images/gisagro4.0/crop-map.png" />
        <u><b>แผนที่แปลงเพาะปลูกพืชเศรษฐกิจที่สำคัญ</b></u><br/>
        <p>
        จัดทำแผนที่แปลงเพาะปลูกพืชเศรษฐกิจจากข้อมูลภาพถ่ายดาวเทียม THEOS (ไทยโชต) และภาพถ่ายดาวเทียมรายละเอียดสูง และให้บริการข้อมูลผ่านระบบอินเตอร์เน็ต
        สู่เจ้าหน้าที่เกษตรและเกษตรกร เพื่อให้สามารถปรับปรุงข้อมูลและประเมินผลผลิตพืชเศรษฐกิจอย่างมีประสีทธิภาพ
        </p>
      </div>
      
      <div class="paragraph">
        <img src="/static/images/gisagro4.0/farmer-census.png" />
        <u><b>สำมะโนแปลงเพาะปลูกพืชเศรษฐกิจรายแปลง</b></u><br/>
        <p>
        ดำเนินการโดยร่วมมือกับหน่วยงานด้านการเกษตรและเกษตรกรในพื้นที่ ในการสำรวจและจำแนกพืชเศรษฐกิจ โดยการเชื่อมโยงข้อมูลแปลงเพาะปลูกฯ กับข้อมูลเกษตรกร 
        เพื่อใช้ในการติดตามการเจริญเติบโตของพืช การป้องกันภัยจากโรคระบาด และการวางแผนการบริหารจัดการการเกษตรสู่เกษตรกรและชุมชน
        </p>
      </div>
      
      <div class="paragraph">
        <img src="/static/images/gisagro4.0/ground-pilot.png" />
        <u><b>โครงการนำร่องและสนับสนุน</b></u><br/>
        <p>
        ด้วยโครงการนำร่องและการทำงานกับเกษตรกรอย่างใกล้ชิด เพื่อการทดสอบวิธีการใช้ข้อมูลและทำความเข้าใจเกี่ยวกับประสิทธิภาพการใช้เทคโนโลยีสารสนเทศ 
        ซึ่งเป็นแนวทางปฏิบัติงานและการพัฒนาทักษะในการแก้ไขปัญหาทางการเกษตรอย่างเป็นรูปธรรมและครบวงจร
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
}
</script>
